export default __webpack_public_path__ + "static/media/Snd_TryG.82349ea3.mp3";